"use client";

import React from "react";
import { Loader } from "@/subframe/components/Loader";

function LoadingStatePage() {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 absolute bg-white bg-opacity-30 bg-fixed backdrop-blur-md z-99">
      <div className="flex w-full grow shrink-0 basis-0 flex-col items-center justify-center">
        <div className="flex max-w-[320px] flex-col items-center justify-center gap-6 rounded-full bg-brand-100 px-6 py-6">
          <Loader size="medium" />
        </div>
      </div>
    </div>
  );
}

export default LoadingStatePage;
